import React, { useState, useEffect, useContext, useRef } from 'react';

import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

import { i18n } from '../../translate/i18n';

import api from '../../services/api';
import toastError from '../../errors/toastError';
import {
  FormControl,
  IconButton,
  Typography,
  Box,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { ChevronLeft, ChevronRight, AccessTime } from '@material-ui/icons';
import moment from 'moment';
import 'moment/locale/pt-br';
import { AuthContext } from '../../context/Auth/AuthContext';
import { isArray, capitalize } from 'lodash';
// import DeleteOutline from '@material-ui/icons/DeleteOutline'; // Removido - não utilizado
// import AttachFile from '@material-ui/icons/AttachFile'; // Removido - não utilizado
// import { head } from 'lodash'; // Removido - não utilizado
// import ConfirmationModal from '../ConfirmationModal'; // Removido - não utilizado

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  multFieldLine: {
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: 'relative',
  },

  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  // calendarContainer removido - não utilizado
  // calendarHeader antigo removido - substituído pelo moderno
  calendarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '1px',
    backgroundColor: theme.palette.divider,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
  },
  calendarDay: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  calendarDayHeader: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.875rem',
  },
  calendarDayToday: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  calendarDaySelected: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontWeight: 'bold',
  },
  calendarDayBusy: {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '2px',
      right: '2px',
      width: '6px',
      height: '6px',
      backgroundColor: theme.palette.error.main,
      borderRadius: '50%',
    },
  },
  calendarDayOtherMonth: {
    color: theme.palette.text.disabled,
    backgroundColor: theme.palette.action.disabledBackground,
  },
  eventIndicator: {
    position: 'absolute',
    bottom: '2px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '4px',
    height: '4px',
    backgroundColor: theme.palette.error.main,
    borderRadius: '50%',
  },
  timeSlotsContainer: {
    marginTop: theme.spacing(2),
    maxHeight: '200px',
    overflowY: 'auto',
  },
  modernCalendar: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  calendarHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  calendarTitle: {
    fontWeight: 'bold',
    fontSize: '1.1rem',
  },
  calendarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: theme.spacing(0.5),
  },
  calendarDayHeader: {
    textAlign: 'center',
    fontWeight: 'bold',
    padding: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
  calendarDay: {
    aspectRatio: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: theme.spacing(0.5),
    fontSize: '0.875rem',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  calendarDaySelected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
  },
  calendarDayToday: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  calendarDayBusy: {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '2px',
      right: '2px',
      width: '6px',
      height: '6px',
      backgroundColor: theme.palette.error.main,
      borderRadius: '50%',
    },
  },
  calendarDayOtherMonth: {
    color: theme.palette.text.disabled,
    backgroundColor: theme.palette.action.disabledBackground,
  },
  timePicker: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  timeSlots: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  timeSlot: {
    padding: theme.spacing(1),
    textAlign: 'center',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(0.5),
    cursor: 'pointer',
    fontSize: '0.875rem',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  timeSlotSelected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
  },
  timeSlotBusy: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  timeSlotDisabled: {
    backgroundColor: theme.palette.grey[300],
    color: theme.palette.grey[600],
    cursor: 'not-allowed',
    opacity: 0.5,
  },
}));

const ScheduleSchema = Yup.object().shape({
  contactId: Yup.number().required('Obrigatório'),
  // Campos para Google Calendar (usados também para agendamento interno)
  eventTitle: Yup.string().required('Título do evento é obrigatório'),
  eventDescription: Yup.string().required('Descrição do evento é obrigatória'),
  eventLocation: Yup.string().required('Localização é obrigatória'),
  eventStartDateTime: Yup.string()
    .required('Data/hora de início é obrigatória')
    .test(
      'is-future',
      'Data/hora de início deve ser no futuro',
      value => !value || moment(value).isAfter(moment())
    ),
  eventEndDateTime: Yup.string()
    .required('Data/hora de fim é obrigatória')
    .test(
      'is-after-start',
      'Data/hora de fim deve ser posterior ao início',
      function (value) {
        const { eventStartDateTime } = this.parent;
        if (!eventStartDateTime || !value) return true;
        return moment(value).isAfter(moment(eventStartDateTime));
      }
    ),
  doctorEmail: Yup.string()
    .email('Email inválido')
    .required('Email do médico é obrigatório'),
});

const GoogleScheduleModal = ({
  open,
  onClose,
  scheduleId,
  contactId,
  cleanContact,
  reload,
  ticket,
  /** ID do deal atual (usado para listar e editar agendamentos existentes) */
  dealId,
  /** Contato do ticket (passado pelo pai quando disponível) */
  contact: contactProp,
  /** Produto a agendar quando aberto automaticamente após venda de serviço (evita buscar da deal) */
  initialProductToSchedule,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  // Configurar moment para português
  moment.locale('pt-br');

  // getInitialState removido - não utilizado

  const initialContact = {
    id: '',
    name: '',
  };

  const [schedule, setSchedule] = useState({
    contactId: '',
    sentAt: '',
    // Campos para Google Calendar (usados também para agendamento interno)
    eventTitle: '',
    eventDescription: '',
    eventLocation: '',
    eventStartDateTime: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
    eventEndDateTime: moment()
      .add(1, 'hour')
      .add(30, 'minutes')
      .format('YYYY-MM-DDTHH:mm'),
    doctorEmail: '',
    googleEventId: '',
    productId: null,
  });
  const [currentContact, setCurrentContact] = useState(initialContact);
  const [contacts, setContacts] = useState([initialContact]);
  // const [attachment, setAttachment] = useState(null); // Removido - não utilizado
  // const attachmentFile = useRef(null); // Removido - não utilizado
  // const [confirmationOpen, setConfirmationOpen] = useState(false); // Removido - não utilizado
  const [productEmail, setProductEmail] = useState('');
  const [productsWithEmail, setProductsWithEmail] = useState([]);
  // Endereço da clínica (setting da empresa) usado para preencher a localização
  const [clinicAddress, setClinicAddress] = useState('');
  // Produtos do deal (vêm de /deals/:id, único lugar que devolve description)
  const [dealProducts, setDealProducts] = useState([]);
  // Guarda o que foi preenchido automaticamente, para não sobrescrever edição manual
  const autoFilledRef = useRef({ title: '', description: '', location: '' });
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const [doctorCalendarEvents, setDoctorCalendarEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [currentMonth, setCurrentMonth] = useState(moment());
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  // Slots disponíveis vindos do endpoint n8n/tickets/:ticketId/available-slots (quando há ticket + produto)
  const [availableSlotsFromApi, setAvailableSlotsFromApi] = useState(null);
  const [availableSlotsLoading, setAvailableSlotsLoading] = useState(false);
  // Agendamentos existentes vinculados ao deal (para edição)
  const [dealSchedules, setDealSchedules] = useState([]);
  const [loadingDealSchedules, setLoadingDealSchedules] = useState(false);
  // ID do calendário em edição (pode vir por prop ou ser escolhido na lista do deal)
  const [calendarIdToEdit, setCalendarIdToEdit] = useState(scheduleId || null);

  // Manter estado interno sincronizado com a prop scheduleId
  useEffect(() => {
    setCalendarIdToEdit(scheduleId || null);
  }, [scheduleId]);

  // Função para verificar disponibilidade no calendário
  const checkCalendarAvailability = async values => {
    try {
      setCheckingAvailability(true);

      // Primeiro verificar se o horário está ocupado localmente
      if (isDateTimeOccupied(values.eventStartDateTime)) {
        return {
          available: false,
          message: i18n.t('scheduleModal.validation.timeOccupied'),
        };
      }

      // Verificar disponibilidade no servidor
      const availabilityData = {
        startDateTime: moment(values.eventStartDateTime).toISOString(),
        endDateTime: moment(values.eventEndDateTime).toISOString(),
        userId: user.id,
        // excludeCalendarId: scheduleId ? scheduleId : undefined // Para edição futura
      };

      const { data } = await api.post(
        '/calendar/check-availability',
        availabilityData
      );

      if (data.isAvailable) {
        return {
          available: true,
          message: data.message || 'Horário disponível',
        };
      } else {
        return {
          available: false,
          message: data.message || 'Horário não disponível',
        };
      }
    } catch (err) {
      console.error('Erro ao verificar disponibilidade:', err);
      // Em caso de erro, assumir que está disponível para não bloquear o usuário
      return {
        available: true,
        message: 'Não foi possível verificar disponibilidade',
      };
    } finally {
      setCheckingAvailability(false);
    }
  };

  // Função para buscar eventos do calendário do médico
  const fetchDoctorCalendarEvents = async email => {
    if (!email) {
      setDoctorCalendarEvents([]);
      return;
    }

    try {
      // setLoadingCalendarEvents(true); // Removido - não utilizado

      const { data } = await api.get(`/calendar/by-email?email=${email}`);

      setDoctorCalendarEvents(data.calendars || []);
    } catch (err) {
      console.error('Erro ao buscar eventos do calendário:', err);
      setDoctorCalendarEvents([]);
    } finally {
      // setLoadingCalendarEvents(false); // Removido - não utilizado
    }
  };

  // Carrega o endereço da clínica cadastrado nas configurações da empresa
  useEffect(() => {
    if (!open) return;
    let active = true;
    (async () => {
      try {
        const { data } = await api.get('/settings');
        if (!active) return;
        const setting = Array.isArray(data)
          ? data.find(s => s.key === 'clinicAddress')
          : null;
        setClinicAddress(setting?.value || '');
      } catch (err) {
        console.error('Erro ao carregar endereço da clínica:', err);
      }
    })();
    return () => {
      active = false;
    };
  }, [open]);

  // Produtos da deal, usados para pré-preencher título/descrição.
  // É uma busca isolada de propósito: o fluxo de fetchProductEmail dispara
  // consultas ao Google Calendar e ao n8n, e não deve ser acionado só para
  // preencher dois campos.
  useEffect(() => {
    if (!open || calendarIdToEdit) return;
    const id = dealId || ticket?.deal?.id || ticket?.dealId;
    if (!id) return;

    let active = true;
    (async () => {
      try {
        const { data } = await api.get(`/deals/${id}`);
        if (!active) return;
        const produtos = data?.products || data?.deals?.products || [];
        setDealProducts(produtos);
      } catch (err) {
        console.warn('Erro ao carregar produtos para pré-preenchimento:', err);
      }
    })();
    return () => {
      active = false;
    };
  }, [open, calendarIdToEdit, dealId, ticket]);

  // Preenche título/descrição pelo produto e localização pelo endereço da clínica.
  // Só sobrescreve campo vazio ou que ainda tem o valor preenchido automaticamente,
  // para nunca descartar o que o usuário digitou. Não roda em modo edição.
  useEffect(() => {
    if (!open || calendarIdToEdit) return;

    const selectedProduct =
      productsWithEmail.find(p => p.email === productEmail) ||
      initialProductToSchedule ||
      dealProducts[0] ||
      null;

    // O produto selecionado nem sempre chega completo: a fila pós-venda é
    // montada a partir de /deals/:id/sale-with-schedules, que devolve só
    // productId/name/email/quantity — sem description. Por isso a descrição é
    // resolvida em /deals/:id (que traz o campo), casando pelo id do produto.
    const productFromDeal = selectedProduct
      ? dealProducts.find(
          p => String(p.id) === String(selectedProduct.id ?? selectedProduct.productId)
        )
      : null;

    const nextTitle = selectedProduct?.name || productFromDeal?.name || '';
    const nextDescription =
      selectedProduct?.description || productFromDeal?.description || '';
    const nextLocation = clinicAddress || '';

    setSchedule(prev => {
      const auto = autoFilledRef.current;
      const next = { ...prev };

      if (nextTitle && (!prev.eventTitle || prev.eventTitle === auto.title)) {
        next.eventTitle = nextTitle;
      }
      if (
        nextDescription &&
        (!prev.eventDescription || prev.eventDescription === auto.description)
      ) {
        next.eventDescription = nextDescription;
      }
      if (
        nextLocation &&
        (!prev.eventLocation || prev.eventLocation === auto.location)
      ) {
        next.eventLocation = nextLocation;
      }

      autoFilledRef.current = {
        title: next.eventTitle === nextTitle ? nextTitle : auto.title,
        description:
          next.eventDescription === nextDescription
            ? nextDescription
            : auto.description,
        location:
          next.eventLocation === nextLocation ? nextLocation : auto.location,
      };

      return next;
    });
  }, [
    open,
    calendarIdToEdit,
    productEmail,
    productsWithEmail,
    initialProductToSchedule,
    dealProducts,
    clinicAddress,
  ]);

  // Função para buscar os emails dos produtos da deal
  const fetchProductEmail = async () => {
    try {
      if (!ticket) {
        setProductsWithEmail([]);
        setProductEmail('');
        return;
      }
      const activeDealId = ticket?.deal?.id;
      if (!activeDealId) {
        toast.warning(i18n.t('scheduleModal.validation.noDeal'));
        setProductsWithEmail([]);
        setProductEmail('');
        return;
      }

      const { data: dealData } = await api.get(`/deals/${activeDealId}`);

      if (!dealData?.products || !Array.isArray(dealData.products)) {
        toast.warning(i18n.t('scheduleModal.validation.noProducts'));
        setProductsWithEmail([]);
        setProductEmail('');
        return;
      }

      const productsWithEmails = dealData.products.filter(
        product => product.email && product.email.trim() !== ''
      );

      if (productsWithEmails.length === 0) {
        toast.warning(i18n.t('scheduleModal.validation.noProductEmail'));
        setProductsWithEmail([]);
        setProductEmail('');
        return;
      }

      setProductsWithEmail(productsWithEmails);
      setProductEmail(productsWithEmails[0].email);
      await fetchDoctorCalendarEvents(productsWithEmails[0].email);
    } catch (err) {
      console.error('Erro ao buscar emails dos produtos:', err);
      setProductsWithEmail([]);
      setProductEmail('');
      toastError(err);
    }
  };

  // Busca horários disponíveis via n8n (baseado no produto vendido no deal)
  const fetchAvailableSlots = async (date, durationMinutes = 30) => {
    if (!ticket?.id || !user?.id || !user?.companyId || !productEmail) {
      setAvailableSlotsFromApi(null);
      return;
    }
    try {
      setAvailableSlotsLoading(true);
      setAvailableSlotsFromApi(null);
      const dateStr = moment(date).format('YYYY-MM-DD');
      const { data } = await api.get(
        `/n8n/tickets/${ticket.id}/available-slots`,
        {
          params: {
            date: dateStr,
            durationMinutes,
          },
        }
      );
      setAvailableSlotsFromApi({
        date: dateStr,
        slots: data.slots || [],
        product: data.product,
        doctorEmail: data.doctorEmail,
        workingHours: data.workingHours,
      });
    } catch (err) {
      // Silencioso: não exibir mensagem de erro ao usuário em caso de falha
      setAvailableSlotsFromApi(null);
    } finally {
      setAvailableSlotsLoading(false);
    }
  };

  // Função para lidar com mudança do email selecionado
  const handleEmailChange = async selectedEmail => {
    setProductEmail(selectedEmail);
    // Buscar eventos do calendário do médico para o novo email
    if (selectedEmail) {
      await fetchDoctorCalendarEvents(selectedEmail);
    }
  };

  useEffect(() => {
    if (contactId && contacts.length) {
      const contact = contacts.find(c => c.id === contactId);
      if (contact) {
        setCurrentContact(contact);
      }
    }
  }, [contactId, contacts]);

  // Atualizar o campo doctorEmail quando productEmail for carregado (apenas para novo agendamento)
  useEffect(() => {
    if (productEmail && !calendarIdToEdit) {
      setSchedule(prevState => ({
        ...prevState,
        doctorEmail: productEmail,
      }));
    }
  }, [productEmail, calendarIdToEdit]);

  // Buscar eventos do calendário quando o email do médico for alterado
  useEffect(() => {
    if (schedule.doctorEmail && schedule.doctorEmail !== productEmail) {
      fetchDoctorCalendarEvents(schedule.doctorEmail);
    }
  }, [schedule.doctorEmail]);

  // Buscar agendamentos existentes do deal (para permitir edição)
  useEffect(() => {
    const currentDealId =
      dealId || ticket?.deal?.id || ticket?.dealId || ticket?.deal?.dealId;

    if (!open || !currentDealId) {
      setDealSchedules([]);
      return;
    }

    (async () => {
      try {
        setLoadingDealSchedules(true);
        const { data } = await api.get(`/deals/${currentDealId}/schedules`);
        const schedules = data?.schedules || [];
        setDealSchedules(schedules);
        // Só entrar em modo edição se NÃO houver initialProductToSchedule (fila de agendamentos).
        // Quando há produto na fila, sempre criar novo agendamento para aquele produto.
        if (schedules.length > 0 && !initialProductToSchedule) {
          setCalendarIdToEdit(schedules[0].id);
        } else if (initialProductToSchedule) {
          setCalendarIdToEdit(null);
        }
      } catch (err) {
        console.error('Erro ao buscar agendamentos do deal:', err);
      } finally {
        setLoadingDealSchedules(false);
      }
    })();
  }, [
    open,
    dealId,
    ticket?.deal?.id,
    ticket?.dealId,
    ticket?.deal?.dealId,
    initialProductToSchedule?.id,
  ]);

  // Buscar slots disponíveis via n8n quando há ticket, produto e data selecionada
  const selectedDateStr = selectedDate ? selectedDate.format('YYYY-MM-DD') : null;
  useEffect(() => {
    if (open && ticket?.id && productEmail && selectedDateStr) {
      fetchAvailableSlots(selectedDate);
    } else {
      setAvailableSlotsFromApi(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, ticket?.id, productEmail, selectedDateStr]);

  // handleStartDateTimeChange removido - não utilizado

  // Função para verificar se uma data/hora está ocupada
  const isDateTimeOccupied = dateTime => {
    if (!doctorCalendarEvents.length) return false;

    const targetDateTime = moment(dateTime);

    return doctorCalendarEvents.some(event => {
      const eventStart = moment(event.startDateTime);
      const eventEnd = moment(event.endDateTime);

      // Verificar se o horário solicitado conflita com algum evento existente
      return (
        targetDateTime.isBetween(eventStart, eventEnd, null, '[)') ||
        targetDateTime.isSame(eventStart, 'minute')
      );
    });
  };

  // Função para obter eventos de uma data específica
  const getEventsForDate = date => {
    if (!doctorCalendarEvents.length) return [];

    const targetDate = moment(date).format('YYYY-MM-DD');

    return doctorCalendarEvents.filter(event => {
      const eventDate = moment(event.startDateTime).format('YYYY-MM-DD');
      return eventDate === targetDate;
    });
  };

  // Função para verificar se uma data tem eventos
  const hasEventsOnDate = date => {
    return getEventsForDate(date).length > 0;
  };

  // Função para gerar os dias do calendário
  const generateCalendarDays = () => {
    const startOfMonth = currentMonth.clone().startOf('month');
    const endOfMonth = currentMonth.clone().endOf('month');
    const startOfCalendar = startOfMonth.clone().startOf('week');
    const endOfCalendar = endOfMonth.clone().endOf('week');

    const days = [];
    const day = startOfCalendar.clone();

    while (day.isSameOrBefore(endOfCalendar, 'day')) {
      days.push(day.clone());
      day.add(1, 'day');
    }

    return days;
  };

  // Função para navegar no calendário
  const navigateMonth = direction => {
    setCurrentMonth(prev => prev.clone().add(direction, 'month'));
  };

  // Função para selecionar uma data
  const handleDateSelect = (date, setFieldValue) => {
    setSelectedDate(date);
    const formattedDate = date.format('YYYY-MM-DD');
    const currentTime = moment().format('HH:mm');
    const newStartDateTime = `${formattedDate}T${currentTime}`;
    const newEndDateTime = moment(newStartDateTime)
      .add(30, 'minutes')
      .format('YYYY-MM-DDTHH:mm');

    setFieldValue('eventStartDateTime', newStartDateTime);
    setFieldValue('eventEndDateTime', newEndDateTime);
  };

  // Função para gerar horários disponíveis (fallback quando não usa n8n available-slots)
  const generateTimeSlots = date => {
    const slots = [];
    const startHour = 8;
    const endHour = 18;

    for (let hour = startHour; hour < endHour; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = moment(date).hour(hour).minute(minute);
        const timeString = time.format('YYYY-MM-DDTHH:mm');
        const isBusy = isDateTimeOccupied(timeString);

        slots.push({
          time: timeString,
          display: time.format('HH:mm'),
          isBusy,
          moment: time,
        });
      }
    }

    return slots;
  };

  // Retorna slots para o seletor: sempre gera grade completa e marca ocupados
  const getTimeSlotsForPicker = date => {
    const dateStr = moment(date).format('YYYY-MM-DD');
    const slots = [];
    const startHour = 8;
    const endHour = 18;

    // Quando a API retorna slots para a data: horário disponível só se estiver na lista com available: true.
    // Horários que não aparecem na resposta (ex.: 12:30 no almoço) devem ser considerados ocupados.
    let apiAvailableTimes = null;
    if (
      availableSlotsFromApi &&
      availableSlotsFromApi.date === dateStr &&
      Array.isArray(availableSlotsFromApi.slots)
    ) {
      apiAvailableTimes = new Set();
      availableSlotsFromApi.slots.forEach(s => {
        if (s.available) {
          const startMoment = moment(s.start);
          apiAvailableTimes.add(startMoment.format('HH:mm'));
        }
      });
    }

    // Gerar todos os slots de 30 em 30 minutos
    for (let hour = startHour; hour < endHour; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = moment(date).hour(hour).minute(minute).second(0);
        const timeString = time.format('YYYY-MM-DDTHH:mm');
        const displayTime = time.format('HH:mm');

        // Se temos dados da API para esta data: ocupado quando o horário NÃO está na lista de disponíveis
        const isBusyFromApi =
          apiAvailableTimes !== null && !apiAvailableTimes.has(displayTime);
        const isBusyFromCalendar = isDateTimeOccupied(timeString);
        const isBusy = isBusyFromApi || isBusyFromCalendar;

        slots.push({
          time: timeString,
          display: displayTime,
          isBusy,
          moment: time,
        });
      }
    }

    return slots;
  };

  // Função para renderizar o calendário moderno
  const renderModernCalendar = (values, setFieldValue) => {
    const startOfMonth = moment(currentMonth).startOf('month');
    const endOfMonth = moment(currentMonth).endOf('month');
    const startOfCalendar = startOfMonth.clone().startOf('week');
    const endOfCalendar = endOfMonth.clone().endOf('week');

    const days = [];
    const day = startOfCalendar.clone();

    while (day.isSameOrBefore(endOfCalendar, 'day')) {
      days.push(day.clone());
      day.add(1, 'day');
    }

    const weekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

    return (
      <Box className={classes.modernCalendar}>
        <Box className={classes.calendarHeader}>
          <IconButton
            onClick={() =>
              setCurrentMonth(currentMonth.clone().subtract(1, 'month'))
            }
            size='small'
          >
            <ChevronLeft />
          </IconButton>
          <Typography className={classes.calendarTitle}>
            {currentMonth.format('MMMM [de] YYYY')}
          </Typography>
          <IconButton
            onClick={() =>
              setCurrentMonth(currentMonth.clone().add(1, 'month'))
            }
            size='small'
          >
            <ChevronRight />
          </IconButton>
        </Box>

        <Box className={classes.calendarGrid}>
          {weekDays.map(dayName => (
            <Box key={dayName} className={classes.calendarDayHeader}>
              {dayName}
            </Box>
          ))}
          {days.map(day => {
            const isToday = day.isSame(moment(), 'day');
            const isSelected = day.isSame(selectedDate, 'day');
            const isCurrentMonth = day.isSame(currentMonth, 'month');
            const isBusy = getEventsForDate(day).length > 0;

            return (
              <Box
                key={day.format('YYYY-MM-DD')}
                className={`
                  ${classes.calendarDay}
                  ${isSelected ? classes.calendarDaySelected : ''}
                  ${isToday ? classes.calendarDayToday : ''}
                  ${isBusy ? classes.calendarDayBusy : ''}
                  ${!isCurrentMonth ? classes.calendarDayOtherMonth : ''}
                `}
                onClick={() => {
                  if (isCurrentMonth) {
                    setSelectedDate(day);
                    // Limpar horários selecionados ao mudar de data
                    setSelectedTimeSlots([]);
                    setFieldValue('eventStartDateTime', '');
                    setFieldValue('eventEndDateTime', '');
                  }
                }}
              >
                {day.format('D')}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  // Função para renderizar o seletor de horário moderno
  const renderModernTimePicker = (values, setFieldValue) => {
    const timeSlots = getTimeSlotsForPicker(selectedDate);

    // Função para verificar se um horário é consecutivo
    const isConsecutiveSlot = (newSlot, existingSlots) => {
      if (existingSlots.length === 0) return true;

      const sortedSlots = [...existingSlots, newSlot].sort((a, b) =>
        moment(a.time).diff(moment(b.time))
      );

      // Verificar se todos os horários são consecutivos (intervalo de 30 minutos)
      for (let i = 0; i < sortedSlots.length - 1; i++) {
        const currentTime = moment(sortedSlots[i].time);
        const nextTime = moment(sortedSlots[i + 1].time);
        const diffMinutes = nextTime.diff(currentTime, 'minutes');

        if (diffMinutes !== 30) {
          return false;
        }
      }
      return true;
    };

    // Função para alternar seleção de horário
    const toggleTimeSlot = slot => {
      if (slot.isBusy) return;

      const isSelected = selectedTimeSlots.some(
        selected => selected.time === slot.time
      );

      if (isSelected) {
        // Remover horário selecionado
        const newSelectedSlots = selectedTimeSlots.filter(
          selected => selected.time !== slot.time
        );
        setSelectedTimeSlots(newSelectedSlots);

        // Se era o primeiro horário, atualizar eventStartDateTime
        if (newSelectedSlots.length === 0) {
          setFieldValue('eventStartDateTime', '');
          setFieldValue('eventEndDateTime', '');
        } else {
          // Manter o primeiro horário como início
          const firstSlot = newSelectedSlots[0];
          setFieldValue('eventStartDateTime', firstSlot.time);
          const endDateTime = moment(firstSlot.time)
            .add(30 * newSelectedSlots.length, 'minutes')
            .format('YYYY-MM-DDTHH:mm');
          setFieldValue('eventEndDateTime', endDateTime);
        }
      } else {
        // Verificar se o novo horário é consecutivo
        if (!isConsecutiveSlot(slot, selectedTimeSlots)) {
          // Mostrar toast de erro
          toast.error(
            'Selecione apenas horários consecutivos (intervalos de 30 minutos)'
          );
          return;
        }

        // Adicionar horário selecionado
        const newSelectedSlots = [...selectedTimeSlots, slot].sort((a, b) =>
          moment(a.time).diff(moment(b.time))
        );
        setSelectedTimeSlots(newSelectedSlots);

        // Atualizar campos de data/hora
        const firstSlot = newSelectedSlots[0];
        setFieldValue('eventStartDateTime', firstSlot.time);
        const endDateTime = moment(firstSlot.time)
          .add(30 * newSelectedSlots.length, 'minutes')
          .format('YYYY-MM-DDTHH:mm');
        setFieldValue('eventEndDateTime', endDateTime);
      }
    };

    return (
      <Box className={classes.timePicker}>
        <Box display='flex' alignItems='center' marginBottom={2}>
          <AccessTime style={{ marginRight: '8px' }} />
          <Typography variant='h6'>
            Horários disponíveis - {selectedDate.format('DD/MM/YYYY')}
            {availableSlotsLoading && ' (carregando...)'}
          </Typography>
        </Box>
        <Typography
          variant='caption'
          color='textSecondary'
          style={{ marginBottom: '16px', display: 'block' }}
        >
          <span role='img' aria-label='Dica'>
            💡
          </span>{' '}
          Selecione apenas horários consecutivos (intervalos de 30 minutos)
        </Typography>
        <Box className={classes.timeSlots}>
          {timeSlots.map((slot, index) => {
            const isSelected = selectedTimeSlots.some(
              selected => selected.time === slot.time
            );

            // Verificar se este horário pode ser selecionado (é consecutivo)
            const canBeSelected =
              !slot.isBusy &&
              (selectedTimeSlots.length === 0 ||
                isConsecutiveSlot(slot, selectedTimeSlots));

            // Determinar o tooltip baseado no estado
            let tooltipText = '';
            if (slot.isBusy) {
              tooltipText = 'Horário já agendado';
            } else if (isSelected) {
              tooltipText = 'Clique para remover';
            } else if (canBeSelected) {
              tooltipText = 'Clique para selecionar';
            } else {
              tooltipText = 'Selecione horários consecutivos apenas';
            }

            return (
              <Box
                key={index}
                className={`
                  ${classes.timeSlot}
                  ${slot.isBusy ? classes.timeSlotBusy : ''}
                  ${isSelected ? classes.timeSlotSelected : ''}
                  ${!canBeSelected && !slot.isBusy && !isSelected ? classes.timeSlotDisabled : ''}
                `}
                onClick={() => toggleTimeSlot(slot)}
                title={tooltipText}
                style={{
                  cursor:
                    canBeSelected || isSelected ? 'pointer' : 'not-allowed',
                  opacity:
                    !canBeSelected && !slot.isBusy && !isSelected ? 0.5 : 1,
                }}
              >
                {slot.display}
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  useEffect(() => {
    if (!user) return; // Verificar se user existe

    const { companyId } = user;
    if (open) {
      try {
        (async () => {
          // Contato fixo do ticket atual (atendimento em andamento) - não é selecionável
          const ticketContact =
            contactProp || ticket?.contact;
          const ticketContactId = ticketContact?.id ?? contactId;
          if (ticketContactId) {
            setSchedule(prevState => ({ ...prevState, contactId: ticketContactId }));
            // Usar contact passado pelo pai ou do ticket quando disponível
            if (ticketContact?.name) {
              setCurrentContact({ id: ticketContact.id, name: ticketContact.name });
            } else {
              // Fallback: buscar contato por ID quando contact não vier preenchido
              try {
                const { data: contactData } = await api.get(`/contacts/${ticketContactId}`);
                if (contactData?.name) {
                  setCurrentContact({ id: contactData.id, name: contactData.name });
                }
              } catch (err) {
                console.error('Erro ao buscar contato:', err);
                const { data: contactList } = await api.get('/contacts/list', {
                  params: { companyId },
                });
                const customList = contactList?.map(c => ({ id: c.id, name: c.name })) || [];
                const contact = customList.find(c => c.id === ticketContactId);
                if (contact) setCurrentContact(contact);
              }
            }
          }

          // Produto pré-definido (ex.: após venda de serviço) ou buscar produtos da deal
          if (initialProductToSchedule?.id && initialProductToSchedule?.email) {
            setProductsWithEmail([initialProductToSchedule]);
            setProductEmail(initialProductToSchedule.email);
            await fetchDoctorCalendarEvents(initialProductToSchedule.email);
          } else {
            await fetchProductEmail();
          }

          if (!calendarIdToEdit) return;

          const { data } = await api.get(`/calendar/${calendarIdToEdit}`);
          // Mapear campos da API (title, description, location) para o estado do formulário (eventTitle, eventDescription, eventLocation)
          const startFormatted = data.startDateTime
            ? moment(data.startDateTime).format('YYYY-MM-DDTHH:mm')
            : undefined;
          const endFormatted = data.endDateTime
            ? moment(data.endDateTime).format('YYYY-MM-DDTHH:mm')
            : undefined;
          setSchedule(prevState => ({
            ...prevState,
            contactId: data.contactId ?? prevState.contactId,
            eventTitle: data.title ?? prevState.eventTitle,
            eventDescription: data.description ?? prevState.eventDescription,
            eventLocation: data.location ?? prevState.eventLocation,
            eventStartDateTime: startFormatted || prevState.eventStartDateTime,
            eventEndDateTime: endFormatted || prevState.eventEndDateTime,
            doctorEmail: data.doctorEmail ?? prevState.doctorEmail,
            // GET /calendar/:id retorna googleEventId quando o evento existe no Google
            googleEventId: data.googleEventId ?? prevState.googleEventId ?? '',
            productId: data.productId ?? prevState.productId ?? null,
          }));
          setCurrentContact(data.contact || initialContact);
          if (data.startDateTime) {
            setSelectedDate(moment(data.startDateTime));
          }
          if (data.product) {
            setProductsWithEmail([data.product]);
            if (data.product.email) setProductEmail(data.product.email);
          } else if (data.doctorEmail) {
            setProductEmail(data.doctorEmail);
            // Garantir que o e-mail do agendamento exista na lista de opções do Select
            setProductsWithEmail(prev => {
              const already = prev.some(p => p.email === data.doctorEmail);
              if (already) return prev;
              return [
                ...prev,
                {
                  id: data.productId || 0,
                  name: 'E-mail do agendamento',
                  email: data.doctorEmail,
                },
              ];
            });
          }
        })();
      } catch (err) {
        toastError(err);
      }
    }
  }, [
    calendarIdToEdit,
    contactId,
    open,
    user,
    initialProductToSchedule?.id,
    ticket?.contact?.id,
    contactProp?.id,
  ]);

  /**
   * Fecha o modal. Opcionalmente recebe result: { saved: true } quando o usuário
   * salvou o agendamento com sucesso (para fluxo "agendar antes de vender").
   * Quando chamado pelo Dialog (backdrop/escape), result pode ser (event, reason).
   */
  const handleClose = result => {
    const isSavedResult =
      result && typeof result === 'object' && result.saved === true;
    if (typeof onClose === 'function') {
      onClose(isSavedResult ? result : undefined);
    }
    // setAttachment(null); // Removido - não utilizado
    setSchedule({
      contactId: '',
      sentAt: '',
      eventTitle: '',
      eventDescription: '',
      eventLocation: '',
      eventStartDateTime: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
      eventEndDateTime: moment()
        .add(1, 'hour')
        .add(30, 'minutes')
        .format('YYYY-MM-DDTHH:mm'),
      doctorEmail: '',
      googleEventId: '',
      productId: null,
    });
    setProductEmail('');
    setProductsWithEmail([]);
    setDealProducts([]);
    setSelectedTimeSlots([]);
    setAvailableSlotsFromApi(null);
    setDealSchedules([]);
    setCalendarIdToEdit(null);
    autoFilledRef.current = { title: '', description: '', location: '' };
    // initialProductToSchedule é controlado pelo pai (fila), não limpar aqui
  };

  // const handleAttachmentFile = e => {
  //   const file = head(e.target.files);
  //   if (file) {
  //     setAttachment(file);
  //   }
  // }; // Removido - não utilizado

  const handleSaveSchedule = async values => {
    const selectedProduct = productsWithEmail.find(
      p => p.email === (values.doctorEmail || productEmail)
    );
    const doctorEmailToSend =
      values.doctorEmail || selectedProduct?.email || '';
    const contactIdToSend =
      values.contactId || currentContact?.id || contactId;

    const productIdToSend =
      values.productId ??
      selectedProduct?.id ??
      initialProductToSchedule?.id ??
      null;

    const calendarData = {
      ...values,
      userId: user.id,
      companyId: user.companyId,
      contactId: contactIdToSend,
      startDateTime: values.eventStartDateTime,
      endDateTime: values.eventEndDateTime,
      title: values.eventTitle,
      description: values.eventDescription,
      location: values.eventLocation,
      doctorEmail: doctorEmailToSend,
      timeZone: 'America/Sao_Paulo',
      ...(productIdToSend != null && { productId: productIdToSend }),
      ...(dealId != null && dealId !== '' && { dealId }),
      // Só pede sincronização com o Google quando há e-mail de médico: o backend
      // exige doctorEmail sempre que syncWithGoogle é true e rejeitava o
      // agendamento inteiro quando o produto não tinha e-mail cadastrado.
      syncWithGoogle: Boolean(doctorEmailToSend),
      // googleEventId vindo do GET /calendar/:id — essencial para o backend localizar o evento no Google ao editar
      ...((values.googleEventId || schedule.googleEventId) && {
        googleEventId: values.googleEventId || schedule.googleEventId,
      }),
    };
    try {
      if (calendarIdToEdit) {
        await api.put(`/calendar/${calendarIdToEdit}`, calendarData);
      } else {
        await api.post('/calendar', calendarData);
      }
      toast.success(i18n.t('scheduleModal.success'));
      if (typeof reload == 'function') {
        reload();
      }
      if (contactId) {
        if (typeof cleanContact === 'function') {
          cleanContact();
          history.push('/schedules');
        }
      }
    } catch (err) {
      toastError(err);
    }
    setCurrentContact(initialContact);
    setSchedule({
      contactId: '',
      sentAt: '',
      eventTitle: '',
      eventDescription: '',
      eventLocation: '',
      eventStartDateTime: moment().add(1, 'hour').format('YYYY-MM-DDTHH:mm'),
      eventEndDateTime: moment()
        .add(1, 'hour')
        .add(30, 'minutes')
        .format('YYYY-MM-DDTHH:mm'),
      doctorEmail: '',
      googleEventId: '',
      productId: null,
    });
    handleClose({ saved: true });
  };

  const handleMarkScheduleActivityAsCompleted = async values => {
    try {
      // Verificar se há ticket e deal
      if (ticket && ticket.deal && ticket.deal.id) {
        // Encontrar o requirement do tipo 'schedule'
        const scheduleRequirement = ticket.deal.stage?.requirements?.find(
          req => req.type === 'schedule'
        );

        if (scheduleRequirement) {
          // Enviar a data/hora do agendamento como valor (formato ISO string)
          const scheduleDateTime = moment(
            values.eventStartDateTime
          ).toISOString();

          await api.post(
            `/deals/${ticket.deal.id}/requirement/${scheduleRequirement.id}`,
            {
              value: scheduleDateTime, // Data/hora do agendamento no formato ISO
            }
          );

          toast.success('Atividade de agendamento marcada como executada!');
        } else {
          console.warn('Nenhum requirement do tipo schedule encontrado');
        }
      } else {
        console.warn(
          'Ticket ou deal não disponível para marcar atividade como executada'
        );
      }
    } catch (err) {
      console.error('Erro ao marcar atividade como executada:', err);
      toastError(err);
    }
  };

  // const deleteMedia = async () => {
  //   if (attachment) {
  //     setAttachment(null);
  //     attachmentFile.current.value = null;
  //   }

  //   if (schedule.mediaPath) {
  //     await api.delete(`/schedules/${schedule.id}/media-upload`);
  //     setSchedule(prev => ({
  //       ...prev,
  //       mediaPath: null,
  //     }));
  //     toast.success(i18n.t('scheduleModal.toasts.deleted'));
  //     if (typeof reload == 'function') {
  //       reload();
  //     }
  //   }
  // }; // Removido - não utilizado

  return (
    <div className={classes.root}>
      {/* ConfirmationModal removido - não utilizado */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='xs'
        fullWidth
        scroll='paper'
      >
        <DialogTitle id='form-dialog-title'>
          {schedule.status === 'ERRO'
            ? 'Erro de Envio'
            : calendarIdToEdit
              ? `${i18n.t('scheduleModal.title.edit')} ${capitalize(schedule.status)}`
              : (() => {
                  const serviceName =
                    productsWithEmail.find(p => p.email === productEmail)?.name ||
                    productsWithEmail[0]?.name ||
                    initialProductToSchedule?.name ||
                    availableSlotsFromApi?.product?.name ||
                    schedule?.product?.name;
                  return serviceName
                    ? i18n.t('scheduleModal.title.addWithService', {
                        service: serviceName,
                      })
                    : i18n.t('scheduleModal.title.add');
                })()}
        </DialogTitle>
        {/* Input de arquivo removido - não utilizado */}
        <Formik
          initialValues={schedule}
          enableReinitialize={true}
          validationSchema={ScheduleSchema}
          onSubmit={async (values, actions) => {
            setTimeout(async () => {
              try {
                // 1. Verificar disponibilidade no calendário
                const availabilityCheck =
                  await checkCalendarAvailability(values);

                if (!availabilityCheck.available) {
                  toast.error(availabilityCheck.message);
                  actions.setSubmitting(false);
                  return;
                }

                // 2. Se disponível, mostrar mensagem de sucesso da verificação
                if (
                  availabilityCheck.message !==
                  'Não foi possível verificar disponibilidade'
                ) {
                  toast.success(availabilityCheck.message);
                }

                // 3. Salvar o agendamento (POST /calendar com syncWithGoogle: true já sincroniza com o Google)
                await handleSaveSchedule(values);

                // 4. Marcar atividade de agendamento como executada
                await handleMarkScheduleActivityAsCompleted(values);
              } catch (err) {
                toastError(err);
              } finally {
                actions.setSubmitting(false);
              }
            }, 400);
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <Form>
              <DialogContent dividers>
                {/* Lista de agendamentos existentes do deal (para edição) */}
                {dealSchedules.length > 0 && (
                  <Box mb={2}>
                    <FormControl variant='outlined' fullWidth>
                      <InputLabel>Agendamentos deste negócio</InputLabel>
                      <Select
                        label='Agendamentos deste negócio'
                        value={calendarIdToEdit || ''}
                        onChange={e => {
                          const value = e.target.value;
                          if (!value) {
                            // Novo agendamento
                            setCalendarIdToEdit(null);
                            setSchedule(prev => ({
                              ...prev,
                              eventTitle: '',
                              eventDescription: '',
                              eventLocation: '',
                              eventStartDateTime: moment()
                                .add(1, 'hour')
                                .format('YYYY-MM-DDTHH:mm'),
                              eventEndDateTime: moment()
                                .add(1, 'hour')
                                .add(30, 'minutes')
                                .format('YYYY-MM-DDTHH:mm'),
                            }));
                          } else {
                            const selectedId = Number(value);
                            setCalendarIdToEdit(selectedId);
                          }
                        }}
                      >
                        <MenuItem value=''>
                          <em>Novo agendamento</em>
                        </MenuItem>
                        {dealSchedules.map(scheduleItem => (
                          <MenuItem
                            key={scheduleItem.id}
                            value={scheduleItem.id}
                            disabled={!calendarIdToEdit}
                          >
                            <Box>
                              <Typography variant='body2' style={{ fontWeight: 'bold' }}>
                                {scheduleItem.productName || 'Agendamento'}
                              </Typography>
                              <Typography variant='caption' color='textSecondary'>
                                {(() => {
                                  try {
                                    const date = moment(
                                      scheduleItem.startDateTime
                                    );
                                    return date.isValid()
                                      ? date.format('DD/MM/YYYY [às] HH:mm')
                                      : scheduleItem.startDateTime;
                                  } catch {
                                    return scheduleItem.startDateTime;
                                  }
                                })()}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                )}

                <div className={classes.multFieldLine}>
                  <TextField
                    label={i18n.t('scheduleModal.form.contact')}
                    value={
                      contactProp?.name ||
                      ticket?.contact?.name ||
                      currentContact?.name ||
                      (contactId ? contacts.find(c => c.id === contactId)?.name : '') ||
                      ''
                    }
                    variant='outlined'
                    fullWidth
                    disabled
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </div>
                <div
                  className={classes.multFieldLine}
                  style={{ marginTop: 16 }}
                >
                  <Field
                    as={TextField}
                    label={i18n.t('scheduleModal.form.eventTitle')}
                    name='eventTitle'
                    error={touched.eventTitle && Boolean(errors.eventTitle)}
                    helperText={touched.eventTitle && errors.eventTitle}
                    variant='outlined'
                    fullWidth
                  />
                </div>
                <br />
                <div className={classes.multFieldLine}>
                  <Field
                    as={TextField}
                    label={i18n.t('scheduleModal.form.eventDescription')}
                    name='eventDescription'
                    multiline
                    rows={3}
                    error={
                      touched.eventDescription &&
                      Boolean(errors.eventDescription)
                    }
                    helperText={
                      touched.eventDescription && errors.eventDescription
                    }
                    variant='outlined'
                    fullWidth
                  />
                </div>
                <br />
                <div className={classes.multFieldLine}>
                  <Field
                    as={TextField}
                    label={i18n.t('scheduleModal.form.eventLocation')}
                    name='eventLocation'
                    error={
                      touched.eventLocation && Boolean(errors.eventLocation)
                    }
                    helperText={touched.eventLocation && errors.eventLocation}
                    variant='outlined'
                    fullWidth
                  />
                </div>
                <br />
                {/* Calendário moderno para seleção de data e hora */}
                {(values.doctorEmail || productEmail) && (
                  <>
                    {renderModernCalendar(values, setFieldValue)}
                    {renderModernTimePicker(values, setFieldValue)}
                  </>
                )}
                <br />
                <div className={classes.multFieldLine}>
                  <FormControl variant='outlined' fullWidth>
                    <InputLabel>E-mail de agendamento</InputLabel>
                    <Select
                      value={values.doctorEmail || productEmail || ''}
                      onChange={e => {
                        const selectedEmail = e.target.value;
                        setFieldValue('doctorEmail', selectedEmail);
                        handleEmailChange(selectedEmail);
                      }}
                      label='E-mail de agendamento'
                      disabled={productsWithEmail.length === 0}
                    >
                      {productsWithEmail.length > 0 ? (
                        productsWithEmail.map((product, index) => (
                          <MenuItem key={index} value={product.email}>
                            <Box>
                              <Typography
                                variant='body2'
                                style={{ fontWeight: 'bold' }}
                              >
                                {product.name}
                              </Typography>
                              <Typography
                                variant='caption'
                                color='textSecondary'
                              >
                                {product.email}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>
                          <Typography variant='body2' color='textSecondary'>
                            Nenhum produto com email encontrado
                          </Typography>
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
                <br />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color='secondary'
                  disabled={isSubmitting}
                  variant='outlined'
                >
                  {i18n.t('scheduleModal.buttons.cancel')}
                </Button>
                {(schedule.sentAt === null || schedule.sentAt === '') && (
                  <Button
                    type='submit'
                    color={
                      values.eventStartDateTime &&
                      isDateTimeOccupied(values.eventStartDateTime)
                        ? 'secondary'
                        : 'primary'
                    }
                    disabled={isSubmitting || checkingAvailability}
                    variant='contained'
                    className={classes.btnWrapper}
                  >
                    {checkingAvailability
                      ? i18n.t('scheduleModal.buttons.checkingAvailability')
                      : values.eventStartDateTime &&
                          isDateTimeOccupied(values.eventStartDateTime)
                        ? i18n.t('scheduleModal.buttons.scheduleBusy')
                        : calendarIdToEdit
                          ? i18n.t('scheduleModal.buttons.okEdit')
                          : i18n.t('scheduleModal.buttons.okAdd')}
                    {(isSubmitting || checkingAvailability) && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default GoogleScheduleModal;
